import ChatListItem, { ChatListItemProps } from "../../ChatListItem";
import { IGroupChatData } from "@home-health-notify/domain";

interface NonPatientChatListItemProps {
  chatData: IGroupChatData;
  isSelected: boolean;
  isHidden?: boolean;
}

function InternalGroupChatListItem({
  chatData,
  isSelected,
  isHidden = false,
}: NonPatientChatListItemProps) {
  let groupInfo = chatData.groupInfo;
  const chatItemProps: ChatListItemProps = {
    chatData,
    isSelected,
    avatarText: groupInfo.name,
    title: groupInfo.name,
    image: groupInfo.image,
    groupType: groupInfo.groupType,
  };
  return <ChatListItem {...chatItemProps} isHidden={isHidden} />;
}

export default InternalGroupChatListItem;
